import { ModelHelper } from '../classes/model-helper';

export class Dongle {
	dongleId: string;

	/**
	 *
	 *
	 * Static mapping function
	 *
	 *
	 *
	 * @param data
	 * @param item
	 * @returns Dongle
	 */
	static map(data: any, item: Dongle = new Dongle()): Dongle {
		return item.map(data);
	}

	/**
	 *
	 *
	 * Non static mapping function
	 *
	 *
	 *
	 * @param data
	 * @return Dongle
	 */
	public map(data: any): Dongle {
		ModelHelper.map(data, this, 'dongleId');

		return this;
	}

	/**
	 * Prepare data for API
	 *
	 * @param data
	 */
	public getDataForApi(data: any = this): any {
		return data;
	}
}
